'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.setupAccordionGroup = undefined;

require('styles/components/accordion.scss');

// Callback for an accordion item being clicked.
// Parameters:
//    index:     the index of the current item in the array of accordion items
//    def:       the current accordion item
//    tiles:     the full list of tiles/accordion items
//    manyOopen: whether multiple tiles in the group may be open at the same time
var handleAccordionToggle = function handleAccordionToggle(index, def, tiles, manyOpen) {
  // Check if we only want the one tab open at a time
  if (!manyOpen) {
    closeAll(tiles, index);
  }
  def.classList.toggle('is-open');
};

// Makes sure all other accordion items in a group are closed
var closeAll = function closeAll(tiles, ignoreIndex) {
  tiles.forEach(function (def, index) {
    if (index !== ignoreIndex) {
      def.classList.remove('is-open');
    }
  });
};

// For each accordion in the group, add click listener to toggle the accordion description
var setupAccordionGroup = exports.setupAccordionGroup = function setupAccordionGroup(tiles) {
  var manyOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  tiles.forEach(function (def, index) {
    def.addEventListener('click', function (event) {
      handleAccordionToggle(index, def, tiles, manyOpen);
    });
  });
};

var dom = {
  toggle: '[data-accordion-toggle]',
  content: '[data-accordion-content]'
};

var bindUIActions = function bindUIActions() {
  $(document).on('click', dom.toggle, function (event) {
    var $this = $(event.currentTarget);
    var hideOthers = $this.hasClass('js-hide-others');
    var $content = $this.siblings(dom.content);
    var isActive = $this.hasClass('is-active');

    if (hideOthers && !isActive) {
      $(dom.toggle).removeClass('is-active');
      $(dom.content).slideUp(200);
      $this.addClass('is-active');
      $content.slideDown(200);
    } else {
      $this.toggleClass('is-active');
      $content.slideToggle(200);
    }
  });
};

var init = exports.init = function init() {
  bindUIActions();
};